"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _axios = _interopRequireDefault(require("axios"));

var _qs = require("qs");

var _basic = _interopRequireDefault(require("./_basic"));

var _bluebird = _interopRequireDefault(require("bluebird"));

function paramsSerializer(params) {
  return (0, _qs.stringify)(params, {
    arrayFormat: 'brackets'
  });
}

var StoreApi =
/*#__PURE__*/
function (_BasicApi) {
  (0, _inherits2.default)(StoreApi, _BasicApi);

  /**
   * @constructor
   */
  function StoreApi(_ref) {
    var _this;

    var userTokenFactory = _ref.userTokenFactory,
        storeApiUrl = _ref.storeApiUrl;
    (0, _classCallCheck2.default)(this, StoreApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(StoreApi).call(this, {
      userTokenFactory: userTokenFactory
    }));
    _this.storeApiUrl = storeApiUrl;
    return _this;
  } // sb


  (0, _createClass2.default)(StoreApi, [{
    key: "getPackages",
    value: function () {
      var _getPackages = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(params, _ref2) {
        var _this2 = this;

        var type, _ref3, headers;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                type = _ref2.type;
                _context.next = 3;
                return this.getHeaders();

              case 3:
                _ref3 = _context.sent;
                headers = _ref3.headers;
                return _context.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this2.storeApiUrl, "/api/v1/packages/").concat(type), {
                    headers: headers,
                    params: params,
                    paramsSerializer: paramsSerializer
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPackages(_x, _x2) {
        return _getPackages.apply(this, arguments);
      }

      return getPackages;
    }() // library

  }, {
    key: "getSandbox",
    value: function () {
      var _getSandbox = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(params, _ref4) {
        var _this3 = this;

        var type, _ref5, headers;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                type = _ref4.type;
                _context2.next = 3;
                return this.getHeaders();

              case 3:
                _ref5 = _context2.sent;
                headers = _ref5.headers;
                return _context2.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this3.storeApiUrl, "/api/v1/sandbox/").concat(type), {
                    headers: headers,
                    params: params,
                    paramsSerializer: paramsSerializer
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSandbox(_x3, _x4) {
        return _getSandbox.apply(this, arguments);
      }

      return getSandbox;
    }() // sb

  }, {
    key: "getCategories",
    value: function () {
      var _getCategories = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(params, _ref6) {
        var _this4 = this;

        var type, _ref7, headers;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                type = _ref6.type;
                _context3.next = 3;
                return this.getHeaders();

              case 3:
                _ref7 = _context3.sent;
                headers = _ref7.headers;
                return _context3.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this4.storeApiUrl, "/api/v1/categories/").concat(type), {
                    headers: headers,
                    params: params
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getCategories(_x5, _x6) {
        return _getCategories.apply(this, arguments);
      }

      return getCategories;
    }()
  }, {
    key: "getCategoryById",
    value: function () {
      var _getCategoryById = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref8, _ref9) {
        var _this5 = this;

        var id, type, _ref10, headers;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                id = _ref8.id;
                type = _ref9.type;
                _context4.next = 4;
                return this.getHeaders();

              case 4:
                _ref10 = _context4.sent;
                headers = _ref10.headers;
                return _context4.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this5.storeApiUrl, "/api/v1/categories/").concat(type, "/id/").concat(id), {
                    headers: headers
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getCategoryById(_x7, _x8) {
        return _getCategoryById.apply(this, arguments);
      }

      return getCategoryById;
    }() // sb

  }, {
    key: "getUploadCredentials",
    value: function () {
      var _getUploadCredentials = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(payload, _ref11) {
        var _this6 = this;

        var type, headers, id, version;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                type = _ref11.type;
                _context5.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context5.sent;
                id = payload.id, version = payload.version;
                return _context5.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.post("".concat(_this6.storeApiUrl, "/api/v1/packages/").concat(type, "/id/").concat(id, "/version/").concat(version), payload, headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getUploadCredentials(_x9, _x10) {
        return _getUploadCredentials.apply(this, arguments);
      }

      return getUploadCredentials;
    }() // sb

  }, {
    key: "getUploadCredentialsSandbox",
    value: function () {
      var _getUploadCredentialsSandbox = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(payload, _ref12) {
        var _this7 = this;

        var type, headers, id, version;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                type = _ref12.type;
                _context6.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context6.sent;
                id = payload.id, version = payload.version;
                return _context6.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.post("".concat(_this7.storeApiUrl, "/api/v1/sandbox/").concat(type, "/id/").concat(id, "/version/").concat(version), payload, headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getUploadCredentialsSandbox(_x11, _x12) {
        return _getUploadCredentialsSandbox.apply(this, arguments);
      }

      return getUploadCredentialsSandbox;
    }() // sb, fb pick ['version', 'baseUrl']

  }, {
    key: "getVersions",
    value: function () {
      var _getVersions = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(_ref13, _ref14) {
        var _this8 = this;

        var id, isSandbox, type, index, _ref15, headers;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                id = _ref13.id, isSandbox = _ref13.isSandbox;
                type = _ref14.type;
                index = isSandbox ? 'sandbox' : 'packages';
                _context7.next = 5;
                return this.getHeaders();

              case 5:
                _ref15 = _context7.sent;
                headers = _ref15.headers;
                return _context7.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this8.storeApiUrl, "/api/v1/").concat(index, "/").concat(type, "/id/").concat(id), {
                    headers: headers
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getVersions(_x13, _x14) {
        return _getVersions.apply(this, arguments);
      }

      return getVersions;
    }() // sb void

  }, {
    key: "deletePackageVersionFromSandbox",
    value: function () {
      var _deletePackageVersionFromSandbox = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(_ref16, _ref17) {
        var _this9 = this;

        var id, version, type, _ref18, headers;

        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                id = _ref16.id, version = _ref16.version;
                type = _ref17.type;
                _context8.next = 4;
                return this.getHeaders();

              case 4:
                _ref18 = _context8.sent;
                headers = _ref18.headers;
                return _context8.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.delete("".concat(_this9.storeApiUrl, "/api/v1/sandbox/").concat(type, "/id/").concat(id, "/version/").concat(version), {
                    headers: headers
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function deletePackageVersionFromSandbox(_x15, _x16) {
        return _deletePackageVersionFromSandbox.apply(this, arguments);
      }

      return deletePackageVersionFromSandbox;
    }() // sb {version}

  }, {
    key: "getPackageMetaLatestVersionById",
    value: function () {
      var _getPackageMetaLatestVersionById = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(_ref19, _ref20) {
        var _this10 = this;

        var id, type, _ref21, headers;

        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                id = _ref19.id;
                type = _ref20.type;
                _context9.next = 4;
                return this.getHeaders();

              case 4:
                _ref21 = _context9.sent;
                headers = _ref21.headers;
                return _context9.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this10.storeApiUrl, "/api/v1/packages/").concat(type, "/id/").concat(id, "/latest"), {
                    headers: headers
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getPackageMetaLatestVersionById(_x17, _x18) {
        return _getPackageMetaLatestVersionById.apply(this, arguments);
      }

      return getPackageMetaLatestVersionById;
    }() // datahub

  }, {
    key: "getMetaByVersion",
    value: function () {
      var _getMetaByVersion = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(_ref22, _ref23) {
        var _this11 = this;

        var id, version, isSandbox, type, index, _ref24, headers;

        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                id = _ref22.id, version = _ref22.version, isSandbox = _ref22.isSandbox;
                type = _ref23.type;
                index = isSandbox ? 'sandbox' : 'packages';
                _context10.next = 5;
                return this.getHeaders();

              case 5:
                _ref24 = _context10.sent;
                headers = _ref24.headers;
                return _context10.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this11.storeApiUrl, "/api/v1/").concat(index, "/").concat(type, "/id/").concat(id, "/version/").concat(version), {
                    headers: headers
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getMetaByVersion(_x19, _x20) {
        return _getMetaByVersion.apply(this, arguments);
      }

      return getMetaByVersion;
    }()
  }, {
    key: "getFavorites",
    value: function () {
      var _getFavorites = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(params, _ref25) {
        var _this12 = this;

        var type, _ref26, headers;

        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                type = _ref25.type;
                _context11.next = 3;
                return this.getHeaders();

              case 3:
                _ref26 = _context11.sent;
                headers = _ref26.headers;
                return _context11.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this12.storeApiUrl, "/api/v1/packages/").concat(type, "/favorites"), {
                    headers: headers,
                    params: params,
                    paramsSerializer: paramsSerializer
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getFavorites(_x21, _x22) {
        return _getFavorites.apply(this, arguments);
      }

      return getFavorites;
    }()
  }]);
  return StoreApi;
}(_basic.default);

var _default = StoreApi;
exports.default = _default;